"use strict";import{IconChevron50 as e}from"../src/elements/IconChevron50.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-chevron50",e);
//# sourceMappingURL=sp-icon-chevron50.js.map
